<!--  -->
<template>
  <div style="padding: 30px;">
    <div>
      <el-button
        type="primary"
        icon="el-icon-back"
        style="margin-bottom: 20px;"
        @click="gobackr"
      >返回</el-button>
    </div>
    <div style="display: flex;align-items: center;">
      <el-input v-model="parmsrs.account_name" style="width: 300px;" placeholder="请输入广告主名称" />
      <el-input v-model="parmsrs.account_id" style="width: 300px;margin-left: 20px;" placeholder="请输入广告主ID" />
      <!-- <el-input v-model="parmsrs.short_name" style="width: 300px;margin-left: 20px;" placeholder="请输入短剧名称" /> -->
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <!-- 汇总信息栏 -->
    <el-card shadow="never" class="summary-card">
      <div class="summary-container">
        <div class="summary-item">
          <div class="summary-label">广告主总数</div>
          <div class="summary-value">{{ reportData.total_account_num || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">短剧总数</div>
          <div class="summary-value">{{ reportData.total_short_num || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">新剧总数</div>
          <div class="summary-value">{{ reportData.total_new_short_num || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">总消耗</div>
          <div class="summary-value">{{ reportData.total_cost || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">总回收</div>
          <div class="summary-value">{{ reportData.total_income || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">总回收扣点</div>
          <div class="summary-value">{{ reportData.total_rebate_income || 0 }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">总回收扣点ROI</div>
          <div class="summary-value">{{ reportData.total_rebate_roi || 0 }}</div>
        </div>
      </div>
    </el-card>
    <el-table
      :data="tableDate"
      border
      size="mini"
      style="width: 100%;margin-top: 20px;"
    >
      <el-table-column prop="account_name" label="广告主名称" width="300" align="center" />
      <el-table-column prop="account_id" label="广告主ID" width="300" align="center" />
      <el-table-column prop="pitcher_name" label="投手名称" width="150" align="center" />
      <!-- <el-table-column prop="short_name" label="短剧名称" width="300" align="center" /> -->
      <el-table-column prop="short_type" label="剧集类型" width="100" align="center" />
      <el-table-column prop="cost" label="消耗" width="100" align="center" />
      <el-table-column prop="income" label="回收" width="100" align="center" />
      <el-table-column prop="rebate_income" label="扣点回收" width="120" align="center" />
      <el-table-column prop="rebate_roi" label="扣点ROI" width="120" align="center" />
      <el-table-column prop="date" label="时间" align="center" />
    </el-table>
    <pagination-right
      :current-page="parmsrs.page"
      :page-sizes="[10]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { pitcherdetaillist } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      parmsrs: {
        page: 1,
        page_size: 10,
        pitcher_id: '',
        account_name: '',
        account_id: '',
        short_name: '',
        start_time: '',
        end_time: ''
      },
      total: null,
      tableDate: [],
      dateRange: [],
      reportData: {}
    }
  },
  created() {
    // 初始化默认今天的日期
    // const today = this.formatDate(new Date())
    // this.dateRange = [today, today]
    // this.parmsrs.start_time = today
    // this.parmsrs.end_time = today
    this.parmsrs.pitcher_id = this.$route.query.id
    console.log(this.$route.query)
    if (this.$route.query.dateRange != null) {
      this.dateRange = this.$route.query.dateRange
      this.parmsrs.start_time = this.dateRange[0]
      this.parmsrs.end_time = this.dateRange[1]
    }
    this.parmsrs.account_name = this.$route.query.account_name
    this.parmsrs.account_id = this.$route.query.account_id
    // this.parmsrs.short_name = this.$route.query.short_name
    this.list()
    // console.log(this.$route.query.id)
  },
  mounted() {

  },
  methods: {
    list() {
      pitcherdetaillist({ ...this.parmsrs }).then((res) => {
        console.log('data', res)
        this.tableDate = res.data.list
        this.total = res.data.count
        this.reportData = res.data
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmsrs.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.parmsrs.page = e
      this.list()
    },
    search() {
      this.parmsrs.page = 1
      this.list()
    },
    reset() {
      this.parmsrs.page = 1
      this.parmsrs.account_name = ''
      this.parmsrs.account_id = ''
      this.parmsrs.short_name = ''
      this.parmsrs.start_time = ''
      this.parmsrs.end_time = ''
      this.dateRange = []
      this.list()
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.parmsrs.start_time = val[0]
        this.parmsrs.end_time = val[1]
      } else {
        this.parmsrs.start_time = ''
        this.parmsrs.end_time = ''
      }
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    gobackr() {
      this.$router.back()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.summary-card {
  background-color: #f9fafc;
  margin-bottom: 10px;
  margin-top: 20px;
}
.summary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.summary-item {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  padding: 10px 15px;
  text-align: center;
}
.summary-label {
  font-size: 13px;
  color: #909399;
}
.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-top: 10px;
}
</style>
